import React from 'react';

const AppContext = React.createContext({
  setLocale: () => {},
});

export default AppContext;
